import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { jsx as _jsx } from "react/jsx-runtime";
const OpenViewConnectionsPanelButton = _ref => {
  let {
      onClick
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TrackableButton, Object.assign({}, buttonProps, {
    trackableKey: Trackables.OPENED_CONNECTIONS_PANEL,
    onClick: onClick,
    children: buttonProps.children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.button.viewConnections"
    })
  }));
};
export default OpenViewConnectionsPanelButton;